import { combineReducers } from 'redux';
import { IRootState } from '../../interfaces/store';
import main from './main';

const rootReducer = combineReducers<IRootState>({
  main
});

export default rootReducer;
